import { Record } from 'immutable';
const HostedEmailAccess = Record({
  canShowAlert: false,
  fromAddress: null
}, 'HostedEmailAccess');
export default HostedEmailAccess;